import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorFuturesMartingale = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="m13.815 7.79 7.248 8.214-1.125.992-7.027-7.964-1.942 1.554a.75.75 0 0 1-.937-1.172l2.202-1.762a1.15 1.15 0 0 1 1.58.138Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M12.75 1.817a1.5 1.5 0 0 0-1.5 0L3.556 6.259a1.5 1.5 0 0 0-.75 1.299v8.884a1.5 1.5 0 0 0 .75 1.299l7.694 4.442a1.5 1.5 0 0 0 1.5 0l7.694-4.442a1.5 1.5 0 0 0 .75-1.3V7.559a1.5 1.5 0 0 0-.75-1.3L12.75 1.818ZM12 3.116l7.694 4.442v8.884L12 20.884l-7.694-4.442V9.547l5.874 6.657a1.15 1.15 0 0 0 1.599.123l2.701-2.251a.75.75 0 1 0-.96-1.152l-2.44 2.033-6.611-7.493 7.53-4.348Z"
    />
  </svg>
);
export default SvgTwoColorFuturesMartingale;
